import { startup } from './src/Startup';
import { Text, TextInput } from 'react-native';

/** These 2 lines access the default props for `Text` and `TextInput`
 * elements globally throughout the app. */
Text.defaultProps = Text.defaultProps || {};
TextInput.defaultProps = TextInput.defaultProps || {};

/** These 2 lines set the default props of the `maxFontSizeMultiplier` property
 * of `Text` and `TextInput` elements to 200% its original value. We do this so that our
 * designs don't get left behind when users scale font to a larger size,
 * while still adhering to accesibility guidelines. */
Text.defaultProps.maxFontSizeMultiplier = 2;
TextInput.defaultProps.maxFontSizeMultiplier = 2;

startup();
